import { Dispatch, FC, useState } from "react";
import {
    Button, Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle
} from "@mui/material";
import DoneIcon from '@mui/icons-material/Done';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { LoadingButton } from "@mui/lab";
import { AxiosInstance } from "axios";
import { AlertType } from "../../types/AlertType";


interface ChangeStatusConfirmationProps {
    open: boolean;
    confirmMessage: string;
    handleClose1: () => void;
    handleClose2?: () => void;
    desactiveDate?: string;
    url: string;
    http: AxiosInstance;
    setError?: Dispatch<React.SetStateAction<boolean>>;
    setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
    setAlerteMessage: Dispatch<React.SetStateAction<string>>;
    setAlertType: Dispatch<React.SetStateAction<AlertType>>;
    handleReload: () => void;
}

const ChangeStatusConfirmation: FC<ChangeStatusConfirmationProps> = ({
    open,
    confirmMessage,
    handleClose1,
    handleClose2,
    desactiveDate,
    url,
    http,
    setError,
    setOpenSnack,
    setAlerteMessage,
    setAlertType,
    handleReload,
}) => {
    const [changeStatutLoading, setChangeStatutLoading] = useState<boolean>(false);

    const handleChangeStatut = async () => {
        setChangeStatutLoading(true);
        await http.put(url, { desactiveDate }).then((res) => {
            const { message, validate } = res?.data;

            if (validate) {
                setAlerteMessage(message);
                setAlertType("success");
                setOpenSnack(true);
                handleClose2 && handleClose2();
                handleReload();
            } else {
                setError && setError(true);
                setAlerteMessage(message);
                setAlertType("warning");
                setOpenSnack(true);
            }
            handleClose1();
        }).catch(error => {
            console.log(error);
            setAlertType("error");
            setOpenSnack(true);
        }).finally(() => {
            setChangeStatutLoading(false);
        });
    };

    return (
        <Dialog
            open={open}
            // TransitionComponent={Transition}
            keepMounted
            onClose={handleClose1}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>{"Confirmation"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    {confirmMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <LoadingButton
                    onClick={() => handleChangeStatut()}
                    endIcon={<DoneIcon />}
                    loading={changeStatutLoading}
                    loadingPosition="end"
                    sx={{ textTransform: "none" }}
                    variant="contained"
                    color="warning"
                >
                    Oui
                </LoadingButton>
                <Button
                    onClick={() => handleClose1()}
                    variant="contained"
                    color="inherit"
                    sx={{ textTransform: "none" }}
                    startIcon={<ExitToAppIcon />}
                >
                    Non
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChangeStatusConfirmation;